import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../../../shared/utils/styles';

export const PreviousDecision = ({small = false}) => {
  const {
    BidStore: { auction: { previousDecision } },
  } = useStores();

  return (
    <PreviousDecisionContainer small={small} className="prevDecision" state={previousDecision.productState}>
      <div>Previous Unit</div>
      {![2, 3, 4].includes(previousDecision.productState) && <div>-</div>}
      {previousDecision?.lotNumber && <div>{previousDecision.lotNumber}</div> }
      {previousDecision?.decision && <div>{previousDecision.decision}</div> }
      {previousDecision?.winner && <div>{previousDecision.winner}</div> }
    </PreviousDecisionContainer>
  );
};

export default observer(PreviousDecision);

export const FlexRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getDecisionColor = (state) => {
  if (state === 4) return { bgColor: '#DB2828', color: '#fff' };
  if (state === 3) return { bgColor: '#21BA45', color: '#000' };
  if (state === 2) return { bgColor: '#FBCC08', color: '#000' };
  return { bgColor: '#e7e7e7', color: '#000' };
};

export const PreviousDecisionContainer = styled(FlexRowContainer)`
  ${({ state }) => css`
    grid-area: bidhistory;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    height: ${props => props.small ? '110px' : '200px'};
    padding: 10px 10px 20px 10px;
    font-weight: bold;
    border-top: 1px black solid;
    background-color: ${getDecisionColor(state).bgColor};
    color: ${getDecisionColor(state).color};
    & > div:nth-child(1) {
      text-transform: uppercase;
      font-weight: bold;
      padding-top: 0px;
      border-bottom: 1px solid gray;
      margin-bottom: 20px;
      font-size: ${props => props.small ? '1.5em' : '2em'}; 
      @media (max-width: ${breakpoints.auctioneer.small}) {
        font-size: 1.5em;
      }
    }
    & div:not(:first-child) {
      margin-bottom: ${props => props.small ? '0px' : '10px'};
      font-size: ${props => props.small ? '1.2em' : '2em'};
      @media (max-width: ${breakpoints.auctioneer.small}) {
        font-size: 1.5em;
      }
    }
  `};
`;
